import React, { Fragment } from "react";

const NoDoughCardMessage = ({ title, message, onClose, className = "" }) => {
  return (
    <Fragment>
      <div className="popup-backdrop"></div>
            <div className={`nodoughcard-popup ${className}`.trim()}>
                <div className="nodoughcard-popup-header">
                    <h2 className="nodoughcard-popup-heading">{title}</h2>
                    <button className="close" onClick={onClose}></button>
                </div>
                <div className="nodoughcard-popup-body">
                    {message}
                </div>
            </div>
    </Fragment>
  );
};

export default NoDoughCardMessage;
